import { render } from "./UserRolesAndPermission.vue?vue&type=template&id=7d3da75c&scoped=true&ts=true"
import script from "./UserRolesAndPermission.vue?vue&type=script&lang=ts"
export * from "./UserRolesAndPermission.vue?vue&type=script&lang=ts"

import "./UserRolesAndPermission.vue?vue&type=style&index=0&id=7d3da75c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3da75c"]])

export default __exports__